import { ruLocale__SkillsChart } from "../../common/skills-chart/locales";
import { ruLocale__PositionBlock } from "../../modules/full-cv/position-block-locales";
import { ruLocale__VisibilityToggles } from "../../modules/full-cv/visibility-toggles-locales";
import { ruLocale__Interview } from "../../modules/interview/locales";
import { ruLocale__MiniCv } from "../../modules/mini-cv/locales";
import { ruLocale__ContactPage } from "../../pages/contact/locales";
import { ruLocale__RightSwitcher } from "../../modules/sunday-top-nav/buttons/right-toggle/locales";
import { ruLocale__TopNavStats } from "../../modules/sunday-top-nav/locales";
import { ruLocale__UserButton } from "../../modules/sunday-top-nav/buttons/user-button/locales";
import { ruLocale__Navigation } from "../../routes/locales";
import { ruLocale__Analytics } from "../../analytics/locales";
import { MergeTranslateKeys } from "../keys";

const messages: MergeTranslateKeys = {
    cardAbout_label: 'О себе',
    footerNoTracking__label: 'Статистика собирается только с вашего согласия',
    ...ruLocale__Analytics,
    ...ruLocale__SkillsChart,
    ...ruLocale__RightSwitcher,
    ...ruLocale__UserButton,
    ...ruLocale__Navigation,
    ...ruLocale__VisibilityToggles,
    ...ruLocale__PositionBlock,
    ...ruLocale__Interview,
    ...ruLocale__ContactPage,
    ...ruLocale__MiniCv,
    ...ruLocale__TopNavStats
}

export default messages;